// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeContestConfirmBody = {
  poolId: string;
  contestId: string;
};

export type typeContestConfirmOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    contestId: string;
    status: "confirmed";
    confirmedAt: string;
    confirmedVia: "commissioner" | "admin" | "auto";
    winners: {
      entryId: string;
      userId: string;
      displayName: string;
      awardGrantId: string;
    }[];
    medalsAwarded: number;
    tieExists: boolean;
  };
};

export type typeContestConfirmOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestConfirmOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestConfirmOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaContestConfirmBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    contestId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "contestId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createContestConfirm(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaContestConfirmBody);
  }

  return async function postContestConfirm(
    payload: typeContestConfirmBody,
  ): Promise<typeContestConfirmOutput200 | typeContestConfirmOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postContestConfirm" failed before calling the network. #3007c84b876a`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#3007c84b876a" },
        },
        data: null,
      } as typeContestConfirmOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/contest/confirm`,
      httpMethod: "POST",
      options,
    })) as typeContestConfirmOutput200 | typeContestConfirmOutput400;
  };
}
